import Axios from "axios";
import dayjs from "dayjs";
import { API_URL } from "../../../DesktopApp";
import { encode } from "html-entities";

// const date = dayjs().format('YYYY-MM-DD HH:mm:ss');

const getAllCandidateSourceList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateSource`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAllCandidatePositionList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidatePosition`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAllCandidateStatusList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateStatus`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const setCandidate = async (data) => {
  console.log(data.get("pdf"))
  const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
 
  try {
    // const response = await Axios.post(
    //   `${API_URL}/desktop/candidates/addcandidate`,
      const response = await Axios.post(`${API_URL}/desktop/candidates/addcandidate`, 
    //   {
    //   create_dt: date,
    //   update_dt: date,
    //   cname: data.get("cname"),
    //   c_ccode: data.get("lccode"),
    //   c_mob: data.get("lmobile"),
    //   c_email: data.get("cemail"),
    //   source: data.get("csource"),
    //   position: data.get("cposition"),
    //   status: data.get("cstatus"),
    //   country: data.get("country") !== null ? data.get("country") : "null",
    //   state: data.get("state") !== null ? data.get("state") : "null",
    //   city: data.get("city"),
    //   locality: data.get("locality"),
    //   followup: data.get("followup"),
    //   followup_dt:
    //     data.get("followup_dt") !== null ? data.get("followup_dt") : "null",
    // }
      data
    );
    return response;
  } catch (err) {
    return err;
  }
};

export {
  getAllCandidateSourceList,
  getAllCandidatePositionList,
  getAllCandidateStatusList,
  setCandidate,
};
